module.exports = __webpack_public_path__ + "img/key-computer.977867c7.svg";